import classNames from 'classnames';
import type { CSSProperties } from 'react';

import List from '@/icon/List';
import X from '@/icon/X';
import { NAVBAR_MENU_BURGER_DEFAULTS } from '@/navbarElement/NavbarMenuBurger';
import type { NavbarMenuBurgerElementProps } from '../../navbarElement/Navbar.type';
import { computeColor } from '../../utils/colors';
import * as styles from '../Navbar.css';
import * as v2Styles from './NavbarMenuBurger.css';
import { NavbarMenuBurgerContentV2 } from './NavbarMenuBurgerContent';

export function NavbarMenuBurgerV2(props: NavbarMenuBurgerElementProps) {
  const { element, className, attributes = {}, children, onClick } = props;
  const {
    color,
    size,
    customAttributes,
    contentBackgroundColor,
    contentPadding,
    contentBorder,
    contentBorderColor,
    contentBorderWidth,
    contentBorderStyle,
    contentBorderRadius,
    gap,
  } = element.attrs || {};
  const isOpen = attributes['data-is-open'] === true;

  return (
    <div className="relative md:hidden block">
      <button
        type="button"
        onClick={onClick}
        {...customAttributes}
        {...attributes}
        className={classNames(styles.navbarMenuBurgerV2, className, customAttributes?.className)}
        style={
          {
            '--text-color': computeColor(color ?? NAVBAR_MENU_BURGER_DEFAULTS.color),
          } as CSSProperties
        }
      >
        <List size={size || NAVBAR_MENU_BURGER_DEFAULTS.size} weight="bold" className={v2Styles.openIconV2} />
        <X size={size || NAVBAR_MENU_BURGER_DEFAULTS.size} weight="bold" className={v2Styles.closeIconV2} />
      </button>

      <NavbarMenuBurgerContentV2
        element={{
          type: 'navbar_menu_burger_content',
          attrs: {
            id: `${element.attrs?.id || 'burger'}-content`,
            background: contentBackgroundColor || '#ffffff',
            padding: contentPadding || '16px',
            gap: gap || '8px',
            border: contentBorder || 'none',
            borderColor: contentBorderColor || 'transparent',
            borderWidth: contentBorderWidth || '0px',
            borderStyle: contentBorderStyle || 'none',
            borderRadius: contentBorderRadius || '0px',
          },
          content: [],
        }}
        attributes={{ 'data-is-open': isOpen }}
      >
        {children}
      </NavbarMenuBurgerContentV2>
    </div>
  );
}
